/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_NameInputs */

const en_mk_sol_lembaga_name = /** @type {(inputs: Mk_Sol_Lembaga_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`institutions, foundations and NGOs`)
};

const id_mk_sol_lembaga_name = /** @type {(inputs: Mk_Sol_Lembaga_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lembaga, yayasan, dan organisasi`)
};

/**
* | output |
* | --- |
* | "institutions, foundations and NGOs" |
*
* @param {Mk_Sol_Lembaga_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_name = /** @type {((inputs?: Mk_Sol_Lembaga_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_name(inputs)
	return en_mk_sol_lembaga_name(inputs)
});